import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Calendar, Flex, Select, Spin } from "antd";
import { SelectArrow, TickIcon } from "../../../../atoms/CustomIcons";
import dayjs from "dayjs";

import "dayjs/locale/zh-cn";

import type { CalendarProps } from "antd";
import type { Dayjs } from "dayjs";
import dayLocaleData from "dayjs/plugin/localeData";

dayjs.extend(dayLocaleData);

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  loading: boolean;
  btnApi: () => void;
}

const RescheduleVisits = (props: PropsType) => {
  const { onClose, loading, btnApi } = props;

  const onCloseHandler = () => {
    onClose();
  };

  const onPanelChange = (value: Dayjs, mode: CalendarProps<Dayjs>["mode"]) => {
    console.log(value.format("YYYY-MM-DD"), mode);
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper rescheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> Reschedule visits </h3>
            <p style={{ color: "#151718" }}>
              Select date and crew to reschedule it to.
            </p>
          </div>
        </div>

        <div className="modal_content">
          <div className="crewLeaderDrop">
            <Select
              style={{ width: "100%" }}
              suffixIcon={<SelectArrow />}
              menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
              showSearch
              allowClear
              placeholder="Select crew leader"
              options={[]}
            />
          </div>
          <div className="reScheduleCalendar">
            <Calendar
              fullscreen={false}
              onPanelChange={onPanelChange}
              headerRender={({ value, onChange }) => {
                const year = value.year();
                const month = value.month();

                const yearOptions = Array.from({ length: 20 }, (_, i) => {
                  const label = year - 10 + i;
                  return { label, value: label };
                });

                const monthOptions = value
                  .localeData()
                  .monthsShort()
                  .map((label, index) => ({
                    label,
                    value: index,
                  }));

                return (
                  <Flex
                    gap={8}
                    justify="space-between"
                    align="center"
                    style={{ marginTop: 8 }}
                  >
                    <div className="calendarLeftTop">
                      <Select
                        size="small"
                        popupMatchSelectWidth={false}
                        value={year}
                        options={yearOptions}
                        onChange={(newYear) => {
                          const now = value.clone().year(newYear);
                          onChange(now);
                        }}
                        suffixIcon={<SelectArrow />}
                      />
                      <Select
                        size="small"
                        popupMatchSelectWidth={false}
                        value={month}
                        options={monthOptions}
                        onChange={(newMonth) => {
                          const now = value.clone().month(newMonth);
                          onChange(now);
                        }}
                        suffixIcon={<SelectArrow />}
                      />
                    </div>
                    <div className="calendarRightTop">
                      <Button
                        onClick={() => {
                          const newMonthValue = value
                            .clone()
                            .subtract(1, "month");
                          onChange(newMonthValue);
                        }}
                        icon={<SelectArrow />}
                        className="prevBtn"
                      />
                      <Button
                        onClick={() => {
                          const newMonthValue = value.clone().add(1, "month");
                          onChange(newMonthValue);
                        }}
                        icon={<SelectArrow />}
                        className="nextBtn"
                      />
                    </div>
                  </Flex>
                );
              }}
            />
          </div>
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            loading={loading}
          >
            Reschedule visits
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default RescheduleVisits;
